export { TrailsPage } from "./trails-page";
